import firebase from "firebase/app";

import { Card, Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import defaultStudioSettings from "astrid-firestore/src/api/studios/defaultStudioSettings";
import { Studio } from "astrid-firestore/src/api/studios/types/Studio";
import updateStudio from "astrid-firestore/src/api/studios/updateStudio";

import Form from "../../../../forms/components/Form/Form";
import useSimpleForm from "../../../../forms/hooks/useSimpleForm";
import PrimaryButton from "../../../../ui/components/Buttons/PrimaryButton";
import ErrorMessage from "../../../../ui/components/Messages/ErrorMessage";

export default function StudioSettingsForm({ studio }) {
	const { t } = useTranslation();

	const { form, formState, error, onSubmit } = useSimpleForm({
		schema: Studio,
		values: {
			settings: studio.settings || defaultStudioSettings,
		},
		onSubmit: (data) => {
			return updateStudio(firebase, studio.ref, data);
		},
	});

	return (
		<>
			<Header as="h3">{t("studioSettings", "Studio settings")}</Header>

			<Card fluid>
				<Card.Content>
					<Form form={form}>
						<Form.Group widths={2}>
							<Form.Select
								name="settings.input"
								options={studio.devices?.inputs || []}
								label={t("incomingSound", "Incoming sound")}
							/>

							<Form.Select
								name="settings.output"
								options={studio.devices?.outputs || []}
								label={t("outgoingSound", "Outgoing sound")}
							/>
						</Form.Group>

						<Form.Group widths={3}>
							<Form.Select
								name="settings.channel"
								label={t("channel", "Channel")}
								options={[
									{
										value: "left",
										text: t("leftChannel", "Left channel"),
									},
									{
										value: "right",
										text: t("rightChannel", "Right channel"),
									},
								]}
							/>
							<Form.Select
								name="settings.releaseChannel"
								label={t("releaseChannel", "Release channel")}
								options={[
									{
										value: "disabled",
										text: t("disableAutoUpdates", "Disable auto-updates"),
									},
									{
										value: "latest",
										text: t("latest", "Latest"),
									},
									{
										value: "beta",
										text: t("beta", "Beta"),
									},
									{
										value: "alpha",
										text: t("alpha", "Alpha"),
									},
								]}
							/>
						</Form.Group>
					</Form>

					{error && <ErrorMessage error={error} />}
				</Card.Content>

				<Card.Content>
					<PrimaryButton
						disabled={formState.isSubmitting || !formState.isDirty}
						loading={formState.isSubmitting}
						onClick={onSubmit}
					>
						{t("save", "Save")}
					</PrimaryButton>
				</Card.Content>
			</Card>
		</>
	);
}
